/* Created by: rja (2017/11/29 20:18) */

(function (PFView, $, undefined) {
    PFView.util = PFView.util || {};

    PFView.util.DEBUG = false;

    var __cUFn = undefined;

    /**
     * Registers an unload message.
     *
     * This method returns the function that will be invoked on the beforeUnload event. This confirmation can be cancelled
     * by calling PFView.util.removeConfirmUnload(confirmUnloadFn)
     *
     *     Note: To combat unwanted pop-ups, some browsers don't display prompts created in beforeunload event handlers unless the page has been interacted with; some don't display them at all.
     *     Note: Attaching an event handler/listener to window or document's beforeunload event prevents browsers from using in-memory page navigation caches, like Firefox's Back-Forward cache or WebKit's Page Cache.

     * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
     * @see https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
     * @param {String} confirmationMessage
     * @returns {function} the function that will be invoked before the unload event happens
     */
    PFView.util.confirmUnload = function (confirmationMessage) {
        if( typeof confirmationMessage !== 'string' ) {
            console.error('confirmationMessage is not a string: ' + confirmationMessage);
            return null;
        }

        var confirmUnloadFn = function (e) {
            e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
            return confirmationMessage;              // Gecko, WebKit, Chrome <34
        };
        window.addEventListener('beforeunload', confirmUnloadFn);

        if( PFView.util.DEBUG ) {
            console.log('[confirm-unload] ACTIVE with message: ' + confirmationMessage);
        }

        __cUFn = confirmUnloadFn;

        return confirmUnloadFn;
    };

    /**
     * Unregisters an unload message
     */
    PFView.util.removeConfirmUnload = function () {
        if( __cUFn === undefined ) {
            console.error('confirmUnloadFn is not defined: ');
            return;
        }

        window.removeEventListener('beforeunload', __cUFn);
        if( PFView.util.DEBUG ) {
            console.log('[confirm-unload] INACTIVE');
        }
    };

    var __saKeepAliveURL = saURL + '/unauthed/keep-alive';
    var __keepAliveInterval = 10 * 60 * 1000; // 10 minutos
    var __keepAliveFn = function(customKeepAliveURL) {
        // Do AJAX ping

        var serverKeepAliveURL;
        if( customKeepAliveURL !== undefined && typeof customKeepAliveURL === 'string' ) {
            serverKeepAliveURL = customKeepAliveURL;
        }
        else {
            var contextRoot;
            var pathname = window.location.pathname;
            if( pathname.indexOf('/') === 0 ) {
                pathname = pathname.substr(1);
            }
            if( pathname.lastIndexOf('/') === pathname.length-1 ) {
                pathname = pathname.substr(0, pathname.length-1);
            }
            var pathParticles = pathname.split('/');
            if( pathParticles.length > 1 ) {
                contextRoot = pathParticles[0] + '/';
            }
            else {
                contextRoot = '';
            }

            serverKeepAliveURL = '//' + window.location.host + '/' + contextRoot + 'pfView/keep-alive';
        }

        $.ajax(serverKeepAliveURL,
               {global: false /* Prevent global ajax event handlers from handling our pings */} )
                .done(function() {if(PFView.util.DEBUG) console.log('[keep-alive] Server pinged at ' + serverKeepAliveURL)})
                .fail(function( jqXHR, textStatus, errorThrown ) {console.error('[keep-alive] Server ping failed at ' + serverKeepAliveURL + ': ' + textStatus + ': ' + errorThrown)});

        $.ajax(__saKeepAliveURL,
               {
                   global: false /* Prevent global ajax event handlers from handling our pings */,
                   xhrFields: {withCredentials: true} /* Permits sending the session cookies to the server */
               })
                .done(function() {if(PFView.util.DEBUG) console.log('[keep-alive] SA pinged at ' + __saKeepAliveURL)})
                .fail(function( jqXHR, textStatus, errorThrown ) {console.error('[keep-alive] SA ping failed at ' + __saKeepAliveURL + ': ' + textStatus + ': ' + errorThrown)});
    };
    var __keepAliveIntervalId = -1;
    /**
     * Toggles keepAlive pings to the server.
     * If need be, the customKeepAliveURL can be set to a server side custom keep-alive URL
     *
     * @param {boolean} toggle
     * @param customKeepAliveURL
     */
    PFView.util.keepAlive = function(toggle, /*optional*/ customKeepAliveURL) {
        if( toggle || toggle == 'true' ) {
            if( PFView.util.DEBUG ) console.log('[keep-alive] ACTIVE with interval ' + (__keepAliveInterval/1000) + 's');
            __keepAliveIntervalId = window.setInterval(__keepAliveFn, __keepAliveInterval, customKeepAliveURL);
        }
        else {
            if( PFView.util.DEBUG ) console.log('[keep-alive] INACTIVE');
            window.clearInterval(__keepAliveIntervalId);
        }
    }



})(window.PFView = window.PFView || {}, jQuery);



/**
 * Created by frito on 03/12/2015.
 */
jQuery(document).ready(function(){
	
	// garantir que a tab ao arrancar não tem pedidos de logout pendentes
	localStorage.removeItem('logout'); // Clear message
	
	// esta variavel permite que no IE a Tab que despoleta o evento não o escute e execute
	var isTabMadeRequest = false;

    /*
     * Submit Logout
     */
    jQuery("#logout-link").on('click', function() {
    	isTabMadeRequest = true;
    	localStorage.setItem("logout", "processLogout");
    });

    /*
     * Register Event
     */
    if (window.addEventListener) {  // Normal browsers
        window.addEventListener("storage", processLogout, false);
    } else {  // for IE (why make your life more difficult)
        window.attachEvent("onstorage", processLogout);
    }
    
    /*
     * Process Logout
     */
    function processLogout(event) {
    	
    	event = event || window.event;

    	// verifica o tipo de evento, a localStorage e se a tab que executa o script é a mesma que despoletou a ação
        var isLogoutEvent = event && event.key === 'logout' && event.newValue === 'processLogout'
            || localStorage.getItem('logout') === 'processLogout';

    	if(!isTabMadeRequest && isLogoutEvent) {

            /*
             * Getting base domain URL...
             */
            var pathArray = location.href.split( '/' );
            var host = pathArray[2];

            if(host.indexOf("localhost") !== -1 || host.indexOf("dev") !== -1) {
                window.location.href = '//portalfin.stinternetdev.ritta.local';

            } else if(host.indexOf("qua") !== -1) {
                window.location.href = '//portalfin.stinternetqua.ritta.local/';

            } else {
                window.location.href = '//www.portaldasfinancas.gov.pt/';
            }
            
        }

    }
    
});

jQuery(document).ready(function(){
	
    // Garantir que a tab ao arrancar não tem pedidos pendentes
    localStorage.removeItem('crosstab-actAs');

    var isLocalRequest = false;

    // Decorar a função representadosList.actLike se esta existir
    if (window.representadosList && typeof window.representadosList.actLike === 'function') {
        var originalActLike = window.representadosList.actLike;

        window.representadosList.actLike = function(nif) {
            isLocalRequest = true;
            localStorage.setItem("crosstab-actAs", nif);
            originalActLike(nif);
        };
    }

    /*
     * Register Event for Storage listener
     */
    if (window.addEventListener) {  // Normal browsers
        window.addEventListener("storage", processActAs, false);
    } else {  // for IE
        window.attachEvent("onstorage", processActAs);
    }

    /*
     * Process ActAs
     */
    function processActAs(event) {
        event = event || window.event;

        // verifica o tipo de evento, a localStorage e se a tab que executa o script é a mesma que despoletou a ação
        var isActAsEvent = (event && event.key === 'crosstab-actAs' && event.newValue)
            || localStorage.getItem('crosstab-actAs');

        var targetNif = (event && event.key === 'crosstab-actAs') ? event.newValue : localStorage.getItem('crosstab-actAs');

        if (!isLocalRequest && isActAsEvent && targetNif) {
            var $form = jQuery("#actLikeForm");
            if ($form.length > 0) {
                jQuery('#actLikeNif').val(targetNif);
                $form.submit();
            }
        }
    }
    
});
/**
 * Created by trodrigues on 2016/06/28.
 */

(function (representados, $, undefined) {
    var __originalData,
        __filteredData,
        __searchInput,
        __tableContainer,
        __offsetStart = 0;

    var elementIsActAsRepresentado = document.getElementById("isActAsRepresentado")

    var isActAsRepresentado = undefined
    if (elementIsActAsRepresentado) {
        isActAsRepresentado = elementIsActAsRepresentado.getAttribute("content") === "true"
    }

    var elemRepresentanteNif = document.getElementById("representanteNif")

    var representanteNif = undefined
    if (elemRepresentanteNif) {
        representanteNif = elemRepresentanteNif.getAttribute("content")
    }


    var __MAX__NUM_ELEMENTS = 5;

    var __reCreateTableContent = function() {
        var fragContent = document.createDocumentFragment();

        // Divs da lista
        for(var i = 0 ; i<__MAX__NUM_ELEMENTS; i++) {
            var clienteLi = document.createElement('li');
            clienteLi.id = 'liCliente_' + i;
            var itemDiv = document.createElement('div');
            itemDiv.className = "pf-item";
            clienteLi.appendChild(itemDiv);
            var itemLeftDiv = document.createElement('div');
            itemLeftDiv.className = " pf-item-left";
            itemDiv.appendChild(itemLeftDiv);
            itemLeftDiv.appendChild(representadosList.createClienteAvatar(i));
            itemLeftDiv.appendChild(representadosList.createClienteInfo(i));
            fragContent.appendChild(clienteLi);
        }

        var noResultLi = document.createElement('li');
        var noResultDiv = document.createElement('div');
        noResultLi.appendChild(noResultDiv);
        var noResultLeftDiv = document.createElement('div');
        noResultLeftDiv.className = " pf-item-left";
        noResultDiv.appendChild(noResultLeftDiv);
        var pName = document.createElement('p');
        pName.id = 'noResult';
        noResultLeftDiv.appendChild(pName);
        fragContent.appendChild(noResultLi);

        __tableContainer = document.createElement('div');
        __tableContainer.appendChild(fragContent);
        return __tableContainer;
    };

    var __createTableHeader = function() {
        return "<li class='pf-col-xs-12 pf-search'>" +
                    "<form class='pf-form-inline'>" +
                        "<input class='pf-form-control pf-pull-left' placeholder='Encontrar...' type='text' id='clientesSearchInput' autocomplete='off'>" +
                    "</form>" +
                "</li>";
    };

    var __createTableFooter = function () {
        return "<li  class='pf-see-all'>" +
          "<div class='pf-item'>" +
          "<div class='pf-item-right'>" +
          "<button type=\"button\" class=\"pf-btn pf-btn-default pf-btn-sm\" data-toggle=\"pf-modal\" data-target=\"#modal-representados\">Ver todos</button>" +
          "</div>" +
          "</div>" +
          "</li>";
    };


    /**
     * Esconde os elementos que não foram preenchidos
     *
     * @param initialValue
     * @private
     */
    var __cleanTableDivs = function (initialValue) {
        // Divs da tabela
        for(var i = initialValue ; i<__MAX__NUM_ELEMENTS; i++) {
            var imgCliente = document.getElementById('repAvatar_'+i);
            var nomeCliente = document.getElementById('repName_'+i);
            var nifCliente  = document.getElementById('repNIF_'+i);
            var roleCliente  = document.getElementById('repRole_'+i);
            imgCliente.src = "";
            nomeCliente.innerHTML = "";
            nifCliente.innerHTML = "";
            roleCliente.innerHTML = "";

            imgCliente.parentElement.parentElement.className = "";
        }
    };


    var __reDraw = function () {
        var countElements = 0;

        __cleanTableDivs(0);

        var liCliente = document.getElementById('liCliente_0');
        var imgSerEu = document.getElementById('repAvatar_0');
        var nomeSerEu = document.getElementById('repName_0');
        var nifSerEu  = document.getElementById('repNIF_0');
        var roleSerEu = document.getElementById('repRole_0');

        var isSerEuInFilteredData = false;
        if (__originalData[0] !== undefined) {
            isSerEuInFilteredData = __filteredData.some(function(cliente) {
                return cliente.nif === __originalData[0].nif;
            });
        }

        if(isSerEuInFilteredData && isActAsRepresentado){
            imgSerEu.src = __originalData[0].avatarUrl;
            liCliente.addEventListener('click', function () {
                representadosList.actLike(__originalData[0].nif);
            });
            nomeSerEu.innerHTML = __originalData[0].nome;
            nifSerEu.innerHTML = __originalData[0].nif;
            roleSerEu.innerHTML = "Atuar em nome pr&oacute;prio";

            imgSerEu.parentElement.parentElement.className = "pf-item";
            countElements++;
        }

        var dataToDraw = __filteredData;
        if (isActAsRepresentado) {
            var nifRepresentado = __originalData[1] ? __originalData[1].nif : undefined;

            dataToDraw = __filteredData.filter(function(cliente) {
                if (representanteNif && cliente.nif === representanteNif) {
                    return false;
                }
                return !nifRepresentado || cliente.nif !== nifRepresentado;
            });
        }

        dataToDraw.some(function (cliente, i) {
            if( i < __offsetStart ) {
                return false; // Not there yet.
            }

            var tableId = i - __offsetStart;
            if(isActAsRepresentado){
                tableId++;
            }

            var liCliente = document.getElementById('liCliente_'+tableId);
            var imgCliente = document.getElementById('repAvatar_'+tableId);
            var nomeCliente = document.getElementById('repName_'+tableId);
            var nifCliente  = document.getElementById('repNIF_'+tableId);
            var roleCliente = document.getElementById('repRole_' + tableId);

            if( tableId < __MAX__NUM_ELEMENTS ) {
                imgCliente.src = cliente.avatarUrl;
                liCliente.addEventListener('click', function () {
                    representadosList.actLike(cliente.nif);
                });
                nomeCliente.innerHTML = cliente.nome;
                nifCliente.innerHTML = cliente.nif;
                roleCliente.innerHTML = "Atuar em nome de";

                imgCliente.parentElement.parentElement.className = "pf-item";
                countElements++;
            }

            return i > __offsetStart + __MAX__NUM_ELEMENTS - 2;
        });

        var noResultElement = document.getElementById('noResult');
        if( countElements === 0 ){
            noResultElement.innerHTML = "Sem resultados";
            noResultElement.parentElement.className = "pf-item-right";
            noResultElement.parentElement.parentElement.className = "pf-item";
        }else{
            noResultElement.innerHTML = "";
            noResultElement.parentElement.className = "";
            noResultElement.parentElement.parentElement.className = "";
        }
    };


    var __createTable = function (mainContainer) {
        if(__originalData.length > __MAX__NUM_ELEMENTS){
            $(mainContainer).append(__createTableHeader());
            $(mainContainer).append(__reCreateTableContent());
            $(mainContainer).append(__createTableFooter());

            $(mainContainer).on('submit', 'form', function(e) {
                e.preventDefault();
            });
        }else{
            $(mainContainer).append(__reCreateTableContent());
        }

        __reDraw();
    };

    var __searchFn = function (overrideSearchStr) {
        var data = __filteredData = __originalData.slice(0);
        __offsetStart = 0;

        var searchStr = overrideSearchStr === undefined ? __searchInput.value : overrideSearchStr;

        if( searchStr === "" ) {
            __reDraw();
            return;
        }

        var searchRegEx = new RegExp(searchStr, 'i');
        for(var i = data.length - 1; i >= 0; i--) {
            var nome = data[i].nome;
            var nif = data[i].nif;
            if( !searchRegEx.test(nome) && !searchRegEx.test(nif) ) {
                data.splice(i, 1);
            }
        }

        __reDraw();
    };


    /**
     * Renderiza o avatar de um cliente
     * @param i índice da célula visível na tabela
     * @returns {DocumentFragment}
     */
    representadosList.createClienteAvatar = function (i) {
        var img = document.createElement('img');
        img.id = 'repAvatar_' + i;
        img.src = '';
        img.alt = '';
        img.className = 'pf-hidden-sm';

        var frag = document.createDocumentFragment();
        frag.appendChild(img);
        return frag;
    };

    /**
     * Renderiza o Nome e NIF de um cliente
     * @param i índice da célula visível na tabela
     * @returns {DocumentFragment}
     */
    representadosList.createClienteInfo = function (i) {
        var pName = document.createElement('p');
        pName.id = 'repName_' + i;

        var pNIF = document.createElement('p');
        pNIF.id = 'repNIF_' + i;

        var pRole = document.createElement('p');
        pRole.id = 'repRole_' + i;

        var div = document.createElement('div');
        div.className = " pf-item-info";
        div.appendChild(pName);
        div.appendChild(pNIF);
        div.appendChild(pRole);

        var frag = document.createDocumentFragment();
        frag.appendChild(div);
        return frag;
    };

    /**
     * Efectua a submissão do formulário 'actLikeForm', com os valores recebidos
     *
     * @param nif
     * @param actLikeCode
     */
    representados.actLike = function (nif) {
        $('#actLikeNif').val(nif);
        $("#actLikeForm").submit();
    };

    /**
     * Efectua a submissão do formulário 'showAllClientsForm'
     */
    representados.showAllClients = function () {
        $("#showAllClientsForm").submit();
    };

    /**
     *
     * @param mainContainer Where the Representados table is draw
     * @param data Clientes data array: [{cliente1.nome, cliente1.nif, cliente1.avatarUrl, cliente1.alertas}, {cliente2.nome, cliente2.nif, cliente2.avatarUrl, cliente2.alertas}]
     * @param actLikeFn Name of the function that activates the Act Like link
     * @returns {representadosList} this
     */
    representadosList.init = function(mainContainer, data) {

        // Init priv vars
        __originalData = data;
        __filteredData = data;
        __tableContainer = undefined;
        __offsetStart = 0;

        /* Draw everything */
        __createTable(mainContainer);

        // Bind search input
        __searchInput = document.getElementById('clientesSearchInput');
        $(__searchInput).on('keyup input', function () {
            __searchFn();
        });

        $(mainContainer).closest('.pf-dropdown').on('shown.bs.dropdown', function () {
            if (__searchInput) {
                __searchInput.focus();
            }
        });

        $(mainContainer).closest('.pf-dropdown').on('hidden.bs.dropdown', function () {
            if (__searchInput) {
                __searchInput.value = '';
                __searchFn();
            }
        });

        $('#modal-representados').on('click', '.pf-act-as-modal-item', function () {
            var nif = $(this).attr('data-nif');
            if (nif) {
                representados.actLike(nif);
            }
        });

        return this;
    };

    return representadosList;
})(window.representadosList = window.representadosList || {}, jQuery);


/**
 * Cumprimento
 */

var currentdate = new Date();
var currentHour = currentdate.getHours();

var cumprimento;

// O if est� invertido, para que o default seja o "Bom dia, "
if (currentHour >= 19 || currentHour < 6) {

    cumprimento = 'Boa noite, ';

} else if (currentHour >= 12 && currentHour < 19) {

    cumprimento = 'Boa tarde, ';

} else {

    // currentHour >= 6 && currentHour < 12
    cumprimento = 'Bom dia, ';

}

var cumpSpan = document.getElementById('cumprimento');

if (cumpSpan !== undefined && cumpSpan !== null && cumpSpan.nodeName == 'SPAN') {
    cumpSpan.innerHTML = cumprimento + cumpSpan.innerHTML;
}

/**
 * Preencher lista de representados caso exista.
 */

jQuery.noConflict();

var representadosDataSize = getHeadMetaProperty('representados-data-size');

if (representadosDataSize !== null) {

    var dataSet = [];

    for (var i = 0; i < parseInt(representadosDataSize); i++) {

        var representado = JSON.parse(
                getHeadMetaProperty('representados-data-' + (i + 1))
        );

        dataSet.push(representado);

    }

    representadosList.init(jQuery('#representados'), dataSet);

}

// Toggle custom pf-dropdown
jQuery(document).ready(function () {
    jQuery(document).on('click', '[data-toggle="pf-dropdown"]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $dropdown = jQuery(this).closest('.pf-dropdown');
        $dropdown.toggleClass('pf-open');
        if ($dropdown.hasClass('pf-open')) {
            $dropdown.trigger('shown.bs.dropdown');
        } else {
            $dropdown.trigger('hidden.bs.dropdown');
        }
    });

    jQuery(document).on('click', function (e) {
        if (!jQuery(e.target).closest('.pf-dropdown').length) {
            var $openDropdowns = jQuery('.pf-dropdown.pf-open');
            if ($openDropdowns.length) {
                $openDropdowns.removeClass('pf-open').trigger('hidden.bs.dropdown');
            }
        }
    });

    // Motor de Modal Manual Autónomo para pf-modal (Isolamento de Clicks)
    jQuery(document).on('click', '[data-toggle="pf-modal"][data-target="#modal-representados"]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Fechar o dropdown de representados quando se abre a modal "Ver todos"
        var $openDropdowns = jQuery('.pf-dropdown.pf-open');
        if ($openDropdowns.length) {
            $openDropdowns.removeClass('pf-open').trigger('hidden.bs.dropdown');
        }

        var $modal = jQuery('#modal-representados');
        
        // Mostrar o Modal com transição de slide e fade
        $modal.css('display', 'block');
        $modal.attr('aria-hidden', 'false'); // Disponibilizar para tecnologias de apoio
        
        setTimeout(function() {
            $modal.addClass('in');
            
            // Focar automaticamente a barra de pesquisa do modal
            var $searchInput = $modal.find('#clientesSearchInput');
            if ($searchInput.length) {
                $searchInput.focus();
            }
        }, 50);
    });

    // Fechar o Modal via botão pf-close, clique no backdrop (fora do diálogo) ou [data-dismiss="modal"]
    jQuery(document).on('click', '#modal-representados, #modal-representados .pf-close, #modal-representados [data-dismiss="modal"]', function (e) {
        // Se o clique foi no próprio backdrop da modal ou em botões de fechar
        if (jQuery(e.target).is('#modal-representados') || jQuery(e.target).closest('.pf-close, [data-dismiss="modal"]').length) {
            e.preventDefault();
            var $modal = jQuery('#modal-representados');
            
            // Remover o foco de qualquer elemento ativo (ex: o botão "Fechar" que acabou de ser clicado)
            // antes de esconder a modal. Isto evita o aviso de "Blocked aria-hidden because descendant retained focus"
            if (document.activeElement && $modal[0].contains(document.activeElement)) {
                document.activeElement.blur();
            }

            $modal.removeClass('in');
            $modal.attr('aria-hidden', 'true'); // Ocultar das tecnologias de apoio de forma segura
            
            // Aguardar o fim da animação CSS (300ms) para limpar do DOM
            setTimeout(function() {
                $modal.css('display', 'none');
                jQuery('body').removeClass('pf-modal-open');
            }, 300);
        }
    });
});


(function() {
    'use strict';

    if (typeof BroadcastChannel === 'undefined') {
        console.warn('BroadcastChannel API não é suportada neste browser.');
        return;
    }

    var channel = new BroadcastChannel("Pfstatic_header");

    function updateMessageCountUI(count) {

        var badge = document.querySelector('[data-role="message-count"]');
        if (!badge) {
            return;
        }


        if (isNaN(count) || count <= 0) {
            badge.textContent = '';
            badge.style.display = 'none';
        } else {
            badge.textContent = count > 9 ? '9+' : count;
            badge.style.display = '';
        }
    }

    channel.onmessage = function(event) {
        if (event.data && typeof event.data.count !== 'undefined') {
            updateMessageCountUI(event.data.count);
        }
    };

    window.broadcastMessageCount = function(newCount) {
        updateMessageCountUI(newCount);
        channel.postMessage({ count: newCount });
    };

    window.addEventListener('beforeunload', function() {
        channel.close();
    });

}());
